import { UserRole } from '../../../shared/enums';

const PermissionsOfAddEditAccount = {
  SeeRateWriterButton: [UserRole.EDITOR],
  SeeAddEditAccountPage: [UserRole.ADMIN, UserRole.EDITOR, UserRole.WRITER],
  SeeDeleteAccountIcon: [UserRole.ADMIN],
  SeeArchiveAccountButton: [UserRole.ADMIN, UserRole.EDITOR],
  SeeUnarchiveAccountButton: [UserRole.ADMIN, UserRole.EDITOR],
  changeWebProfile: [UserRole.ADMIN, UserRole.EDITOR],
};

export default PermissionsOfAddEditAccount;
